__turbopack_context__.v({
  "collapsible": "CollapsibleContainer-module-scss-module__FR_s3W__collapsible",
  "collapsible-container": "CollapsibleContainer-module-scss-module__FR_s3W__collapsible-container",
  "header": "CollapsibleContainer-module-scss-module__FR_s3W__header",
  "title": "CollapsibleContainer-module-scss-module__FR_s3W__title",
  "toggle": "CollapsibleContainer-module-scss-module__FR_s3W__toggle",
});
